import React from 'react';
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';

export const socialLinks = [
  {
    name: 'youtube',
    url: 'https://www.youtube.com/@g_k_shuvo',
    icon: <FaYoutube />,
  },
  {
    name: 'instagram',
    url: 'https://www.instagram.com/g_k_shuvo',
    icon: <FaInstagram />,
  },
  {
    name: 'facebook',
    url: 'https://www.facebook.com/shuvo.2k16',
    icon: <FaFacebook />,
  },
  {
    name: 'twitter',
    url: 'https://www.twitter.com/g_k_shuvo',
    icon: <FaTwitter />,
  },
];
